module.exports = __webpack_public_path__ + "static/img/dawan_cjwt1.3069f70.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/dawan/dawan_cjwt1.png
// module id = 704
// module chunks = 0